import gql from 'graphql-tag';

const UPDATE_SIMULATION_MUTATION = gql`
  mutation(
      $simulationId: ID!,
      $explanation: String!) {  
    updateSimulation(
      simulationId: $simulationId,
      explanation: $explanation,
    ){
      simulationId
      contractId
    }
  }
`;

export default UPDATE_SIMULATION_MUTATION;
